import css from "./FriendListItem.module.css";

function FriendListItem({ friend }) {
  return (
    <li className={css.item}>
      <span className={`${css.status} ${friend.isOnline ? css.online : css.offline}`}></span>

      <img
        className={css.avatar}
        src={friend.avatar}
        alt={friend.name}
        width="48"
      />

      <p className={css.name}>{friend.name}</p>
    </li>
  );
}

export default FriendListItem;